import { useScheme } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { IdSuccess } from "./IdSuccess";
import { InteracLogoEnDark } from "./InteracLogoEnDark";
import { InteracLogoEnLight } from "./InteracLogoEnLight";
import { InteracLogoFrDark } from "./InteracLogoFrDark";
import { InteracLogoFrLight } from "./InteracLogoFrLight";
import { Lock } from "./Lock";

function Logo({ locale, scheme }: { locale: string; scheme: string }) {
  const isFrench = locale.toLowerCase().startsWith("fr");
  const isDark = scheme === "dark";
  if (isFrench) {
    return isDark ? <InteracLogoFrDark /> : <InteracLogoFrLight />;
  }
  return isDark ? <InteracLogoEnDark /> : <InteracLogoEnLight />;
}

export function InteracSessionIllustration() {
  const { i18n } = useTranslation();
  const scheme = useScheme();

  return (
    <div className={styles.container}>
      <div className={styles.illustration}>
        <Logo locale={i18n.language} scheme={scheme} />
        <Lock />
        <IdSuccess />
      </div>
    </div>
  );
}

const styles = {
  container: css({
    width: "100%",
    marginTop: "var(--space-4)",
    marginBottom: "var(--space-4)",
    flex: 1,
    display: "flex",
    justifyContent: "center",
  }),
  illustration: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    maxWidth: 397,
  }),
};
